var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgTrustpilotStars = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "22 22 86 16.19",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#00B67A",
    d: "M36.1882 22H24C22.8954 22 22 22.8954 22 24V36.1882C22 37.2928 22.8954 38.1882 24 38.1882H36.1882C37.2928 38.1882 38.1882 37.2928 38.1882 36.1882V24C38.1882 22.8954 37.2928 22 36.1882 22Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#00B67A",
    d: "M53.5574 22H41.3691C40.2646 22 39.3691 22.8954 39.3691 24V36.1882C39.3691 37.2928 40.2646 38.1882 41.3691 38.1882H53.5574C54.6619 38.1882 55.5574 37.2928 55.5574 36.1882V24C55.5574 22.8954 54.6619 22 53.5574 22Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#00B67A",
    d: "M71.0947 22H58.9065C57.8019 22 56.9065 22.8954 56.9065 24V36.1882C56.9065 37.2928 57.8019 38.1882 58.9065 38.1882H71.0947C72.1993 38.1882 73.0947 37.2928 73.0947 36.1882V24C73.0947 22.8954 72.1993 22 71.0947 22Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#00B67A",
    d: "M88.4617 22H76.2734C75.1689 22 74.2734 22.8954 74.2734 24V36.1882C74.2734 37.2928 75.1689 38.1882 76.2734 38.1882H88.4617C89.5662 38.1882 90.4617 37.2928 90.4617 36.1882V24C90.4617 22.8954 89.5662 22 88.4617 22Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#00B67A",
    d: "M106.001 22H93.8125C92.7079 22 91.8125 22.8954 91.8125 24V36.1882C91.8125 37.2928 92.7079 38.1882 93.8125 38.1882H106.001C107.105 38.1882 108.001 37.2928 108.001 36.1882V24C108.001 22.8954 107.105 22 106.001 22Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "white",
    d: "M29.926 32.7924L32.4554 32.1178L33.4672 35.3218L29.926 32.7924ZM35.6594 28.7453H31.2751L29.926 24.6982L28.577 28.7453H24.3613L27.9025 31.2747L26.5535 35.3218L30.0947 32.7924L32.2868 31.2747L35.6594 28.7453Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "white",
    d: "M47.4628 32.7924L49.9922 32.1178L51.0039 35.3218L47.4628 32.7924ZM53.0275 28.7453H48.6431L47.2941 24.6982L45.9451 28.7453H41.5608L45.102 31.2747L43.7529 35.3218L47.2941 32.7924L49.4863 31.2747L53.0275 28.7453Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "white",
    d: "M64.9996 32.7924L67.529 32.1178L68.5408 35.3218L64.9996 32.7924ZM70.5643 28.7453H66.18L64.831 24.6982L63.482 28.7453H59.0977L62.6388 31.2747L61.4584 35.3218L64.9996 32.7924L67.1918 31.2747L70.5643 28.7453Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "white",
    d: "M82.3683 32.7924L84.8978 32.1178L85.9095 35.3218L82.3683 32.7924ZM88.1017 28.7453H83.7174L82.3683 24.6982L81.0193 28.7453H76.635L80.1762 31.2747L78.8272 35.3218L82.3683 32.7924L84.5605 31.2747L88.1017 28.7453Z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "white",
    d: "M99.9052 32.7924L102.435 32.1178L103.446 35.3218L99.9052 32.7924ZM105.47 28.7453H101.086L99.7366 24.6982L98.5562 28.7453H94.1719L97.713 31.2747L96.364 35.3218L99.9052 32.7924L102.097 31.2747L105.47 28.7453Z"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgTrustpilotStars);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/trustpilot-stars.40e20d664a4e6cdd1f9ba0ede30ca45e.svg";